import {
  CardTypeApi,
  CarePrincipalAdministrationApi,
} from "../../../generated/api";
import { getAPIConfig } from "../../../util/api-config";
import store from "../../configureStore";
import { put } from "@redux-saga/core/effects";
import {
  // COMFACT - KOMMER ATT TAS BORT 
  // setAllAllowedContracts,
  setAllCardTypeConfigurations,
  setAllCarePrincipalAccess,
  setAllJobsConfigurations,
} from "../../reducers/infoReducer";
import { handleError } from "../../../util/errorHandler";
import { setLoading } from "../../reducers/loadingReducer";

function setUpCardClient() {
  return new CardTypeApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

function setUpCarePrincipalClient() {
  return new CarePrincipalAdministrationApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

export function* handleGetAllCardTypeConfigurations(): any {
  try {
    const cardTypeClient = setUpCardClient();
    const response = yield cardTypeClient.getAllCardTypeConfigurations();
    yield put(setAllCardTypeConfigurations(response));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleGetAllCarePrincipalAccess(): any {
  try {
    yield put(setLoading(true));
    const carePrincipalAdminClient = setUpCarePrincipalClient();
    const response = yield carePrincipalAdminClient.getAllCarePrincipalAccess();
    yield put(setAllCarePrincipalAccess(response));
  } catch (error) {
    yield handleError(error);
  } finally {
    yield put(setLoading(false));
  }
}

// COMFACT - KOMMER ATT TAS BORT 
// export function* handleGetAllAllowedContracts(): any {
//   try {
//     const carePrincipalAdminClient = setUpCarePrincipalClient();
//     const response = yield carePrincipalAdminClient.getAllAllowedContracts();
//     yield put(setAllAllowedContracts(response));
//   } catch (error) {
//     yield handleError(error);
//   }
// }

export function* handleGetAllJobsConfiguration(): any {
  try {
    const carePrincipalAdminClient = setUpCarePrincipalClient();
    const response = yield carePrincipalAdminClient.getAllJobsConfigurations();
    yield put(setAllJobsConfigurations(response));
  } catch (error) {
    yield handleError(error);
  }
}
